export default "__VITE_ASSET__SV7TqLjp__"